var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLike(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.6793 2.63978C10.1661 2.63922 9.6593 2.75317 9.19576 2.97332C8.73222 3.19348 8.32365 3.5143 7.99983 3.91239C7.55189 3.36161 6.94491 2.96248 6.26173 2.76946C5.57854 2.57644 4.85244 2.59893 4.18251 2.83388C3.51259 3.06883 2.93148 3.50478 2.51851 4.08223C2.10553 4.65968 1.8808 5.3505 1.875 6.06041C1.875 9.46309 7.99983 13.3607 7.99983 13.3607C7.99983 13.3607 14.1247 9.46804 14.1247 6.06041C14.123 5.60958 14.0326 5.16349 13.8586 4.7476C13.6846 4.33171 13.4303 3.95417 13.1104 3.63653C12.7905 3.3189 12.4111 3.06739 11.994 2.89637C11.5768 2.72534 11.1301 2.63816 10.6793 2.63978Z",
    stroke: "currentColor",
    strokeWidth: 1.4
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLike);
export default __webpack_public_path__ + "static/media/like.83ca7fdf278aec4be2048926422519ea.svg";
export { ForwardRef as ReactComponent };